// типы контролеров которые используем для карты
export enum ControlsType {
  ZoomControl = 'ZoomControl',
  RoutePanel = 'RoutePanel',
  GeolocationControlUnit = 'GeolocationControlUnit',
}
